module.exports = "/_next/static/images/daeb62f32160a501b8ac2713f736320a-opcoes_parcelas.png";